module.exports = __webpack_public_path__ + "static/media/616.360b3e34.webp";